<template>
    <v-card class="grey lighten-4 elevation-3">
        <v-card-title class="subheading">Banca {{ exam.id }}</v-card-title>
        <v-divider></v-divider>
        <v-list three-line>
            <v-list-tile v-for="(header, i) in headers" :key="header.key">
                <v-list-tile-content>{{ header.title }}:</v-list-tile-content>
                <v-list-tile-content class="align-end" style="max-width: 80%">
                    <template v-if="typeof header.formatter === 'undefined'">
                        <p v-if="i == 0">
                            <span v-for="nome in exam.studentName">{{nome}}</span>
                        </p>
                        <p v-else>{{exam[header.key]}}</p>
                    </template>
                    <template v-else>
                        {{ header.formatter(exam) }}
                    </template>
                </v-list-tile-content>
            </v-list-tile>
        </v-list>
    </v-card>
</template>

<script>
    import auth from '../auth'
    import moment from 'moment'

    export default {
        name: 'ExamDetailList',
        props: {
            exam: {
                default: {},
                type: Object
            },
            headers: {
                default: function() {
                    return [
                        { title: 'Aluno', key: 'studentName' },
                        // { title: 'Tema', key: 'topic' },
                        { title: 'Título', key: 'title' },
                        { title: 'Data', key: 'date', formatter: (exam) => { return moment(exam.date, 'YYYY-MM-DD').format('DD/MM/YYYY') + ' às ' + exam.hour + 'h' } },
                        { title: 'Local', key: 'place' }
                    ]
                },
                type: Array
            }
        }
    }
</script>



// WEBPACK FOOTER //
// ExamDetailList.vue?266984e0